import client from './client';

export interface ImportLog {
  id: string;
  status: string;
  created_at: string;
  import_completed_at: string | null;
}

interface ImportLogListResponse {
  logs: ImportLog[];
}

export async function fetchLatestImportLog(): Promise<ImportLog | null> {
  const response = await client.get<ImportLogListResponse>(
    '/map/import-logs',
    { params: { limit: 1 } },
  );
  return response.data.logs[0] ?? null;
}

export async function fetchLatestCompletedImportLog(): Promise<ImportLog | null> {
  const response = await client.get<ImportLogListResponse>(
    '/map/import-logs',
    { params: { limit: 1, status: 'completed' } },
  );
  return response.data.logs[0] ?? null;
}
